import { useState } from "react";
import { Card, btnPrimary, btnSecondary, inputStyle, labelStyle } from "../shared";
import { readOnlyStyle } from "./constants";

export function LandlordPropertySection({ settings, saveSettings, setSettings }) {
  const [editingLandlord, setEditingLandlord] = useState(false);
  const [landlordDraft,   setLandlordDraft]   = useState(null);
  const [landlordSaved,   setLandlordSaved]   = useState(false);
  const [landlordSaving,  setLandlordSaving]  = useState(false);

  const startEditLandlord = () => {
    setLandlordDraft({
      landlordName:    settings.landlordName    || "",
      landlordEmail:   settings.landlordEmail   || "",
      landlordPhone:   settings.landlordPhone   || "",
      propertyAddress: settings.propertyAddress || "",
    });
    setEditingLandlord(true);
  };

  const cancelEditLandlord = () => {
    setEditingLandlord(false);
    setLandlordDraft(null);
  };

  const saveLandlordSection = async () => {
    setLandlordSaving(true);
    setSettings(s => ({ ...s, ...landlordDraft }));
    await saveSettings(landlordDraft, true);
    setLandlordSaved(true);
    setTimeout(() => setLandlordSaved(false), 3000);
    setEditingLandlord(false);
    setLandlordDraft(null);
    setLandlordSaving(false);
  };

  return (
    <Card style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16 }}>Landlord &amp; Property</div>
        {!editingLandlord && (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {landlordSaved && <span style={{ color: "#22c55e", fontSize: 13, fontWeight: 600 }}>✅ Saved!</span>}
            <button onClick={startEditLandlord} style={btnSecondary}>Edit</button>
          </div>
        )}
      </div>

      {!editingLandlord ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {[["Landlord Name","landlordName"],["Landlord Email","landlordEmail"],["Landlord Phone","landlordPhone"],["Address","propertyAddress"]].map(([label, key]) => (
            <div key={key}>
              <label style={labelStyle}>{label}</label>
              <div style={{ ...readOnlyStyle, color: settings[key] ? "#2B2B2B" : "#9B9690" }}>
                {settings[key] || <span style={{ fontStyle: "italic" }}>Not set</span>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {[["Landlord Name","landlordName","text"],["Landlord Email","landlordEmail","email"],["Landlord Phone","landlordPhone","text"],["Address","propertyAddress","text"]].map(([label, key, type]) => (
            <div key={key}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                value={landlordDraft[key]}
                onChange={e => setLandlordDraft(d => ({ ...d, [key]: e.target.value }))}
                style={inputStyle}
              />
            </div>
          ))}
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <button onClick={saveLandlordSection} disabled={landlordSaving} style={{ ...btnPrimary, opacity: landlordSaving ? 0.6 : 1 }}>
              {landlordSaving ? "Saving…" : "Save"}
            </button>
            <button onClick={cancelEditLandlord} style={btnSecondary}>Cancel</button>
          </div>
        </div>
      )}
    </Card>
  );
}
